const meta = {
  'otel-ingest': 'Configure collector',
  'otel-ingest-config': 'Configure ingestion',
  'otlp-endpoints': 'OTLP endpoints',
  'ingest-dogstatsd': 'Ingest DogStatsD',
};

export default meta;
